import { render } from "./AdminRechargeManagement.vue?vue&type=template&id=5197c846&scoped=true"
import script from "./AdminRechargeManagement.vue?vue&type=script&lang=js"
export * from "./AdminRechargeManagement.vue?vue&type=script&lang=js"

import "./AdminRechargeManagement.vue?vue&type=style&index=0&id=5197c846&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5197c846"]])

export default __exports__